<mat-card appearance="outlined">
    <div class="row">
        <div class="col"> 
            <p class="text-center">
                <ng-container *ngIf="error == false">
                    <strong>¿Seguro que quiere eliminar esta tarifa?</strong>
                </ng-container>
                <ng-container *ngIf="error">
                    <strong>Tarifa eliminada</strong>
                </ng-container>
            </p>
            <div class="d-flex justify-content-center flex-column flex-md-row">
                <ng-container *ngIf="error == false">
                    <button mat-stroked-button (click)="delete()" class="me-0 me-md-2 mb-2 mb-md-0">
                        <mat-icon>delete</mat-icon>
                        Eliminar
                    </button>
                </ng-container>
                <button mat-stroked-button (click)="closeDialog()">
                    <mat-icon>close</mat-icon>
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</mat-card>